<template>
  <div class="flex flex-col">
    <label
      class="block font-medium text-gray-700 dark:text-gray-300 mb-1"
      :class="compact ? 'text-xs' : 'text-xs sm:text-sm sm:mb-2'"
    >
      Tonen
    </label>
    <Listbox v-slot="{ open }" :model-value="modelValue" @update:model-value="onChange" multiple>
      <div class="relative">
        <ListboxButton
          class="relative w-full cursor-pointer border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 py-2 pl-2 sm:pl-3 pr-8 text-left focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm text-gray-900 dark:text-white"
          :class="
            open
              ? 'rounded-t-lg rounded-b-none border-b-gray-200 dark:border-b-gray-700'
              : 'rounded-lg'
          "
        >
          <span class="block truncate">{{ selectedLabel }}</span>
          <span class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
            <ChevronUpDownIcon
              class="h-5 w-5 text-gray-400 dark:text-gray-500"
              aria-hidden="true"
            />
          </span>
        </ListboxButton>
        <transition
          leave-active-class="transition duration-100 ease-in"
          leave-from-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <ListboxOptions
            class="absolute z-50 w-max min-w-full max-w-[calc(100vw-2rem)] rounded-b-lg border border-t-0 border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 py-1 text-sm shadow-lg focus:outline-none max-h-96 overflow-x-auto overflow-y-auto"
          >
            <ListboxOption
              v-for="option in options"
              :key="option.value"
              :value="option.value"
              v-slot="{ active, selected }"
              as="template"
            >
              <li
                :class="[
                  active
                    ? 'bg-blue-100 dark:bg-blue-900/50 text-blue-900 dark:text-blue-200'
                    : 'text-gray-900 dark:text-gray-200',
                  'flex items-center gap-2 cursor-pointer select-none py-2 px-3'
                ]"
              >
                <CheckIcon
                  v-if="selected"
                  class="h-4 w-4 flex-shrink-0 text-blue-600 dark:text-blue-400"
                  aria-hidden="true"
                />
                <span
                  class="h-2.5 w-2.5 rounded-full flex-shrink-0"
                  :class="dotClass(option.value)"
                  aria-hidden="true"
                />
                <span
                  :class="[selected ? 'font-medium' : 'font-normal', 'block whitespace-nowrap']"
                >
                  {{ option.label }}
                </span>
              </li>
            </ListboxOption>
          </ListboxOptions>
        </transition>
      </div>
    </Listbox>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { Listbox, ListboxButton, ListboxOptions, ListboxOption } from '@headlessui/vue'
import { ChevronUpDownIcon, CheckIcon } from '@heroicons/vue/24/outline'
import { ACTIVITY_CATEGORY_OPTIONS } from '@/constants/activityCategories.js'

const props = defineProps({
  modelValue: {
    type: Array,
    default: () => []
  },
  compact: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:modelValue'])

const options = ACTIVITY_CATEGORY_OPTIONS

const selectedLabel = computed(() => {
  const sel = props.modelValue || []
  if (sel.length === 0 || sel.length === options.length) return 'Alles'
  return options
    .filter(o => sel.includes(o.value))
    .map(o => o.label)
    .join(', ')
})

const dotClass = value => {
  const map = {
    ziekte: 'bg-rose-500',
    verlof: 'bg-sky-500',
    performance_expertise: 'bg-teal-500',
    projects: 'bg-green-500',
    presourcings: 'bg-purple-500',
    voorstellen: 'bg-yellow-400'
  }
  return map[value] || 'bg-gray-400'
}

const onChange = next => {
  emit('update:modelValue', next)
}
</script>
